<script setup lang="ts">
withDefaults(
    defineProps<{
        subtitleColor?: string
    }>(),
    {
        subtitleColor: 'text-neutral-900',
    }
)
</script>

<template>
    <div class="space-y-2">
        <h2 class="text-xl font-semibold text-neutral-800"><slot /></h2>
        <p v-if="$slots.subtitle" class="text-sm" :class="subtitleColor">
            <slot name="subtitle" />
        </p>
    </div>
</template>
